import { render } from "./ProductDialog.vue?vue&type=template&id=9818cb62"
import script from "./ProductDialog.vue?vue&type=script&lang=js"
export * from "./ProductDialog.vue?vue&type=script&lang=js"

import "./ProductDialog.vue?vue&type=style&index=0&id=9818cb62&lang=scss"
script.render = render

export default script